import { render, staticRenderFns } from "./InvestorOnboardingBpStakeholders.vue?vue&type=template&id=d948d5ba&"
import script from "./InvestorOnboardingBpStakeholders.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingBpStakeholders.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingBpStakeholders.vue?vue&type=style&index=0&id=d948d5ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports